import React from 'react';
import ReactDOM from 'react-dom';
import './style.scss';
import SaleOrderAjax from "./SaleOrderAjax";

ReactDOM.render(
    <SaleOrderAjax/>,
    document.getElementById('SaleOrderAjax')
);

